import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useNavigate, useLocation } from "react-router-dom";
import UsuariosService from "../../service/usuario";
import RegioesService from "../../service/regioes";
import Api from "../../service";
import { CHAMADOS_ATIVO, EXPERIENCIAS_ATIVO } from "../../funcionalidades";

const MenuContainer = styled.nav`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 240px;
  height: 100vh;
  background-color: #008080;
  padding: 20px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  font-family: "Roboto", sans-serif;
  transition: width 0.3s ease;

  @media (min-width: 768px) and (max-width: 1200px) {
    width: ${(props) => (props.$open ? "200px" : "60px")};
    padding: 30px 0 20px 0;
    align-items: center;

    & .menu-text,
    & .menu-title {
      display: ${(props) => (props.$open ? "block" : "none")};
      opacity: ${(props) => (props.$open ? "1" : "0")};
      transition: opacity 0.2s;
    }

    & .menu-item {
      justify-content: ${(props) => (props.$open ? "flex-start" : "center")};
      padding-left: ${(props) => (props.$open ? "10px" : "0")};
    }
  }

  @media (max-width: 767.98px) {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    transform: translateX(${(props) => (props.$open ? "0" : "-100%")});
    transition: transform 0.25s ease-out;
    width: 240px;
  }
`;

const TabletToggle = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  margin-bottom: 10px;
  color: #d9d9d9;

  @media (min-width: 768px) and (max-width: 1200px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
`;

const MenuTitle = styled.div`
  text-align: center;
  margin-bottom: 6px;
  font-family: "Kadwa", sans-serif;
  color: white;
  align-self: center;
  padding-top: 4px;
  line-height: 1.3;
`;

const Title = styled.h1`
  font-size: 28px;
  margin: 0;
`;

const Subtitle = styled.h2`
  font-size: 12px;
  margin: 0;
  font-weight: normal;
`;

const MenuItemContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: 4px;
  overflow-y: auto;
  overflow-x: hidden;

  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &:hover {
    scrollbar-color: rgba(217, 217, 217, 0.5) transparent;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 10px;
  }
  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(217, 217, 217, 0.5);
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(217, 217, 217, 0.8);
  }

  @media (max-width: 767.98px) {
    padding-top: 16px;
  }
`;

const MenuItem = styled(Link)`
  text-decoration: none;
  color: #d9d9d9;
  margin: 10px 0;
  text-align: left;
  width: 100%;
  padding-left: 10px;
  font-size: 1rem;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  display: flex;
  justify-content: left;
  gap: 12px;
`;

const MenuItemSair = styled.div`
  cursor: pointer;
  color: #d9d9d9;
  margin: 10px 0;
  text-align: left;
  width: 100%;
  padding-left: 10px;
  font-size: 1rem;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  display: flex;
  justify-content: left;
  gap: 17px;
`;

const MenuCategoryLabel = styled.div`
  color: #b9dede;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  margin: 18px 0 4px 10px;
  opacity: 0.85;

  @media (min-width: 768px) and (max-width: 1200px) {
    display: ${(props) => (props.$open ? "block" : "none")};
  }
`;

const Icon = styled.svg`
  width: 16px;
  height: 16px;
  fill: #d9d9d9;
`;

const IconFillNone = styled.svg`
  width: 16px;
  height: 16px;
  fill: none;
  stroke: #d9d9d9;
  stroke-width: 1.5;
  stroke-linecap: round;
  stroke-linejoin: round;

  & path {
    fill: none;
    stroke: inherit;
    stroke-width: inherit;
    stroke-linecap: inherit;
    stroke-linejoin: inherit;
  }
`;

const IconDesignacoes = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

const Text = styled.span`
  color: #d9d9d9;
  font-family: "Roboto", sans-serif;
  font-size: 1rem;
  font-weight: 400;
`;

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 960;
  display: none;

  @media (max-width: 1200px) {
    display: ${(props) => (props.$open ? "block" : "none")};
  }
`;

const Menu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [pontosUsuario, setPontosUsuario] = useState([]);
  const [possuiRegiaoEventos, setPossuiRegiaoEventos] = useState(false);
  const [usuarioNoArranjoCarrinhos, setUsuarioNoArranjoCarrinhos] = useState(false);

  const [perfilUsuario, setPerfilUsuario] = useState(() => {
    try {
      const raw = localStorage.getItem("perfilUsuario");
      if (!raw) return [];
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed;
        if (typeof parsed === "string") return [parsed];
      } catch (e) {
        return [raw];
      }
    } catch (e) {
      return [];
    }
  });

  const allowedPages = React.useMemo(() => {
    if (carregando || !perfilUsuario || perfilUsuario.length === 0) return [];

    const perfis = Array.isArray(perfilUsuario) ? perfilUsuario : [perfilUsuario];
    const possuiPontoEventos = (Array.isArray(pontosUsuario) ? pontosUsuario : []).some((ponto) => {
      const nomePonto = String(ponto?.nome || '').trim().toLowerCase();
      return nomePonto === 'eventos';
    });

    const possuiOutrosPontos = (Array.isArray(pontosUsuario) ? pontosUsuario : []).some((ponto) => {
      const nomePonto = String(ponto?.nome || '').trim().toLowerCase();
      return nomePonto !== 'eventos';
    });

    const roleToPages = {
      admin: ["home", "designacoes", "cadastrar", "eventos", "resetar-senhas", "gerenciar-publicadores", "gerenciar-pontos", "gerenciar-arranjos", "suporte", "relatorios", "publicadores", "notificacoes", "comunicacoes-especiais", "experiencias", "swagger", "chamados"],
      colaborador: ["cadastrar", "publicadores"],
      secretaria: possuiPontoEventos
        ? (possuiOutrosPontos ? ["home", "eventos"] : ["eventos"])
        : ["home"],
      "coordenador-geral": ["home", "cadastrar", "designacoes", "eventos", "relatorios", "gerenciar-pontos", "gerenciar-publicadores", "gerenciar-arranjos", "publicadores", "chamados"],
      "coordenador-ponto": possuiPontoEventos ? ["home", "designacoes", "eventos"] : ["home", "designacoes"],
      "coordenador-regional": possuiRegiaoEventos ? ["home", "eventos", "designacoes", "cadastrar"] : ["home", "designacoes", "cadastrar"]
        ? (possuiOutrosPontos ? ["home", "eventos", "chamados"] : ["eventos", "chamados"])
        : ["home", "chamados"],
      "coordenador-geral": ["home", "cadastrar", "designacoes", "eventos", "relatorios", "gerenciar-pontos", "gerenciar-publicadores", "gerenciar-arranjos", "publicadores", "notificacoes", "chamados"],
      "coordenador-ponto": possuiPontoEventos ? ["home", "designacoes", "eventos", "notificacoes", "chamados"] : ["home", "designacoes", "notificacoes", "chamados"],
      "coordenador-regional": possuiRegiaoEventos ? ["home", "eventos", "designacoes", "cadastrar", "notificacoes", "chamados"] : ["home", "designacoes", "cadastrar", "notificacoes", "chamados"]
    };

    const pages = new Set();
    perfis.forEach((role) => {
      const allowed = roleToPages[role];
      if (Array.isArray(allowed)) {
        allowed.forEach((p) => pages.add(p));
      }
    });

    if (usuarioNoArranjoCarrinhos) {
      pages.add("chamados");
    }

    if (!CHAMADOS_ATIVO) pages.delete("chamados");
    if (!EXPERIENCIAS_ATIVO) pages.delete("experiencias");

    if (pages.size === 0) {
      ["home", "designacoes"].forEach((p) => pages.add(p));
    }

    return Array.from(pages);
  }, [carregando, perfilUsuario, pontosUsuario, possuiRegiaoEventos, usuarioNoArranjoCarrinhos]);

  useEffect(() => {
    const id = localStorage.getItem("idUsuario");
    if (!id) {
      setPerfilUsuario([]);
      setCarregando(false);
      return;
    }

    const carregarUsuario = async () => {
      try {
        const u = await UsuariosService.getUsuarioById(id);
        const perfArr =
          u && Array.isArray(u.perfil)
            ? u.perfil
            : u && u.perfil
              ? [u.perfil]
              : [];
        setPerfilUsuario(perfArr);

        // Secretaria: pontos vêm via ponto.coordenadores, não via usuario.pontos
        if (perfArr.includes('secretaria')) {
          try {
            const resp = await Api.get(`pontos/listarPontos?coordenadorId=${id}`);
            setPontosUsuario(Array.isArray(resp.data) ? resp.data : []);
          } catch {
            setPontosUsuario([]);
          }
        } else {
          setPontosUsuario(Array.isArray(u?.pontos) ? u.pontos : []);
        }

        // Verifica se coordenador-regional pertence à região "Eventos"
        if (perfArr.includes('coordenador-regional')) {
          try {
            const regioes = await RegioesService.getRegioes(true);
            const temEventos = Array.isArray(regioes) && regioes.some(
              r => String(r?.nome || '').trim().toLowerCase() === 'eventos'
            );
            setPossuiRegiaoEventos(temEventos);
          } catch {
            setPossuiRegiaoEventos(false);
          }
        }

        if (!perfArr.includes('admin') && !perfArr.includes('coordenador-geral')) {
          try {
            const resp = await Api.get('/arranjos/manutencao-carrinhos/responsaveis');
            const lista = Array.isArray(resp.data) ? resp.data : [];
            const membro = lista.some((item) => {
              const usuarioId = item?.usuario?._id || item?.usuario;
              return String(usuarioId) === String(id);
            });
            setUsuarioNoArranjoCarrinhos(membro);
          } catch {
            setUsuarioNoArranjoCarrinhos(false);
          }
        } else {
          setUsuarioNoArranjoCarrinhos(false);
        }

        try {
          localStorage.setItem("perfilUsuario", JSON.stringify(perfArr));
        } catch (e) {}
      } catch (err) {
        setPerfilUsuario([]);
        setPontosUsuario([]);
      } finally {
        setCarregando(false);
      }
    };

    carregarUsuario();
  }, []);

  useEffect(() => {
    const handler = () => {
      setOpen((prev) => !prev);
    };
    window.addEventListener("toggle-main-menu", handler);
    return () => window.removeEventListener("toggle-main-menu", handler);
  }, []);

  const isAdmin = React.useMemo(() => {
    return perfilUsuario && perfilUsuario.includes("admin");
  }, [perfilUsuario]);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("idUsuario");
    localStorage.removeItem("usuario");
    try {
      localStorage.removeItem("perfilUsuario");
    } catch (e) {}
    navigate("/");
  };

  // ---- Flags de visibilidade de cada categoria: só mostra o título
  // do grupo se o usuário tiver permissão para pelo menos 1 item dele.
  const mostraCoordenacao =
    allowedPages.includes("designacoes") ||
    allowedPages.includes("eventos") ||
    allowedPages.includes("publicadores") ||
    allowedPages.includes("experiencias") ||
    allowedPages.includes("notificacoes");

  const mostraCoordenacaoGeral =
    allowedPages.includes("relatorios") ||
    allowedPages.includes("gerenciar-pontos") ||
    allowedPages.includes("gerenciar-publicadores") ||
    allowedPages.includes("gerenciar-arranjos");

  const mostraCadastroSuporte = allowedPages.includes("cadastrar");

  const mostraAdministrador =
    allowedPages.includes("suporte") || isAdmin || allowedPages.includes("swagger") ||
    allowedPages.includes("comunicacoes-especiais");

  return (
    <>
      <Backdrop $open={open} onClick={() => setOpen(false)} />
      <MenuContainer $open={open}>
        <TabletToggle onClick={() => setOpen(!open)}>
          <Icon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{ width: 24, height: 24 }}
          >
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
          </Icon>
        </TabletToggle>
        <MenuTitle className="menu-title">
          <Title>TPE</Title>
          <Subtitle>Distrito Federal</Subtitle>
        </MenuTitle>
        <MenuItemContainer>

          {/* Home (fora de qualquer categoria) */}
          {allowedPages.includes("home") && (
            <MenuItem to="/home" className="menu-item">
              <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M23.1212 9.06893L15.5362 1.48293C14.5975 0.546917 13.3259 0.0213013 12.0002 0.0213013C10.6746 0.0213013 9.40297 0.546917 8.46421 1.48293L0.879212 9.06893C0.599638 9.34671 0.377982 9.67723 0.227095 10.0413C0.0762075 10.4054 -0.000910129 10.7958 0.000212351 11.1899V21.0069C0.000212351 21.8026 0.316283 22.5656 0.878892 23.1282C1.4415 23.6909 2.20456 24.0069 3.00021 24.0069H21.0002C21.7959 24.0069 22.5589 23.6909 23.1215 23.1282C23.6841 22.5656 24.0002 21.8026 24.0002 21.0069V11.1899C24.0013 10.7958 23.9242 10.4054 23.7733 10.0413C23.6224 9.67723 23.4008 9.34671 23.1212 9.06893V9.06893ZM15.0002 22.0069H9.00021V18.0729C9.00021 17.2773 9.31628 16.5142 9.87889 15.9516C10.4415 15.389 11.2046 15.0729 12.0002 15.0729C12.7959 15.0729 13.5589 15.389 14.1215 15.9516C14.6841 16.5142 15.0002 17.2773 15.0002 18.0729V22.0069ZM22.0002 21.0069C22.0002 21.2721 21.8949 21.5265 21.7073 21.714C21.5198 21.9016 21.2654 22.0069 21.0002 22.0069H17.0002V18.0729C17.0002 16.7468 16.4734 15.4751 15.5357 14.5374C14.5981 13.5997 13.3263 13.0729 12.0002 13.0729C10.6741 13.0729 9.40236 13.5997 8.46468 14.5374C7.527 15.4751 7.00021 16.7468 7.00021 18.0729V22.0069H3.00021C2.735 22.0069 2.48064 21.9016 2.29311 21.714C2.10557 21.5265 2.00021 21.2721 2.00021 21.0069V11.1899C2.00114 10.9249 2.1064 10.6709 2.29321 10.4829L9.87821 2.89993C10.4419 2.33886 11.2049 2.02387 12.0002 2.02387C12.7955 2.02387 13.5585 2.33886 14.1222 2.89993L21.7072 10.4859C21.8933 10.6732 21.9985 10.9259 22.0002 11.1899V21.0069Z" />
              </Icon>
              <Text className="menu-text">Home</Text>
            </MenuItem>
          )}

          {/* Categoria: Coordenação */}
          {mostraCoordenacao && (
            <MenuCategoryLabel $open={open} className="menu-title">Coordenação</MenuCategoryLabel>
          )}

          {allowedPages.includes("designacoes") && (
            <MenuItem to="/designacoes" className="menu-item">
              <IconDesignacoes
                viewBox="0 0 25 24"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
              >
                <path d="M7.37875 5.02326C6.87061 5.02326 6.44922 4.64372 6.44922 4.18605V0.837209C6.44922 0.379535 6.87061 0 7.37875 0C7.88689 0 8.30828 0.379535 8.30828 0.837209V4.18605C8.30828 4.64372 7.88689 5.02326 7.37875 5.02326Z" fill="#D9D9D9" />
                <path d="M17.2928 5.02326C16.7847 5.02326 16.3633 4.64372 16.3633 4.18605V0.837209C16.3633 0.379535 16.7847 0 17.2928 0C17.801 0 18.2223 0.379535 18.2223 0.837209V4.18605C18.2223 4.64372 17.801 5.02326 17.2928 5.02326Z" fill="#D9D9D9" />
                <path d="M7.99719 14.7908C7.83607 14.7908 7.67495 14.7573 7.52623 14.7015C7.36511 14.6457 7.24117 14.5676 7.11723 14.4671C6.89414 14.255 6.75781 13.9759 6.75781 13.6745C6.75781 13.5294 6.79499 13.3843 6.85696 13.2503C6.91893 13.1164 7.00569 12.9936 7.11723 12.882C7.24117 12.7815 7.36511 12.7034 7.52623 12.6476C7.9724 12.4801 8.53012 12.5694 8.87715 12.882C9.10023 13.0941 9.23656 13.3843 9.23656 13.6745C9.23656 13.7415 9.22417 13.8196 9.21178 13.8978C9.19938 13.9648 9.1746 14.0317 9.13741 14.0987C9.11263 14.1657 9.07545 14.2327 9.02587 14.2996C8.98869 14.3555 8.92672 14.4113 8.87715 14.4671C8.64166 14.668 8.31943 14.7908 7.99719 14.7908Z" fill="#D9D9D9" />
                <path d="M12.3351 14.7904C12.174 14.7904 12.0128 14.7569 11.8641 14.7011C11.703 14.6453 11.5791 14.5671 11.4551 14.4667C11.232 14.2546 11.0957 13.9755 11.0957 13.6741C11.0957 13.529 11.1329 13.3839 11.1949 13.2499C11.2568 13.116 11.3436 12.9932 11.4551 12.8816C11.5791 12.7811 11.703 12.703 11.8641 12.6471C12.3103 12.4685 12.868 12.569 13.215 12.8816C13.4381 13.0937 13.5745 13.3839 13.5745 13.6741C13.5745 13.7411 13.5621 13.8192 13.5497 13.8974C13.5373 13.9644 13.5125 14.0313 13.4753 14.0983C13.4505 14.1653 13.4133 14.2323 13.3638 14.2992C13.3266 14.3551 13.2646 14.4109 13.215 14.4667C12.9796 14.6676 12.6573 14.7904 12.3351 14.7904Z" fill="#D9D9D9" />
                <path d="M16.673 14.7904C16.5119 14.7904 16.3507 14.7569 16.202 14.7011C16.0409 14.6453 15.917 14.5671 15.793 14.4667C15.7434 14.4109 15.6939 14.3551 15.6443 14.2992C15.5947 14.2323 15.5575 14.1653 15.5327 14.0983C15.4956 14.0313 15.4708 13.9644 15.4584 13.8974C15.446 13.8192 15.4336 13.7411 15.4336 13.6741C15.4336 13.3839 15.5699 13.0937 15.793 12.8816C15.917 12.7811 16.0409 12.703 16.202 12.6471C16.6606 12.4685 17.2059 12.569 17.5529 12.8816C17.776 13.0937 17.9123 13.3839 17.9123 13.6741C17.9123 13.7411 17.9 13.8192 17.8876 13.8974C17.8752 13.9644 17.8504 14.0313 17.8132 14.0983C17.7884 14.1653 17.7512 14.2323 17.7017 14.2992C17.6645 14.3551 17.6025 14.4109 17.5529 14.4667C17.3174 14.6676 16.9952 14.7904 16.673 14.7904Z" fill="#D9D9D9" />
                <path d="M7.99719 18.6975C7.83607 18.6975 7.67495 18.6641 7.52623 18.6083C7.3775 18.5525 7.24117 18.4742 7.11723 18.3738C6.89414 18.1617 6.75781 17.8715 6.75781 17.5812C6.75781 17.4361 6.79499 17.291 6.85696 17.157C6.91893 17.0119 7.00569 16.8892 7.11723 16.7888C7.5758 16.3757 8.41858 16.3757 8.87715 16.7888C9.10023 17.0009 9.23656 17.291 9.23656 17.5812C9.23656 17.8715 9.10023 18.1617 8.87715 18.3738C8.64166 18.5747 8.31943 18.6975 7.99719 18.6975Z" fill="#D9D9D9" />
                <path d="M12.3351 18.6975C12.0128 18.6975 11.6906 18.5747 11.4551 18.3738C11.232 18.1617 11.0957 17.8715 11.0957 17.5812C11.0957 17.4361 11.1329 17.291 11.1949 17.157C11.2568 17.0119 11.3436 16.8892 11.4551 16.7888C11.9137 16.3757 12.7565 16.3757 13.215 16.7888C13.3266 16.8892 13.4133 17.0119 13.4753 17.157C13.5373 17.291 13.5745 17.4361 13.5745 17.5812C13.5745 17.8715 13.4381 18.1617 13.215 18.3738C12.9796 18.5747 12.6573 18.6975 12.3351 18.6975Z" fill="#D9D9D9" />
                <path d="M16.673 18.6974C16.3507 18.6974 16.0285 18.5746 15.793 18.3737C15.6815 18.2732 15.5947 18.1504 15.5327 18.0053C15.4708 17.8714 15.4336 17.7262 15.4336 17.5811C15.4336 17.436 15.4708 17.2909 15.5327 17.1569C15.5947 17.0118 15.6815 16.889 15.793 16.7886C16.0781 16.5318 16.5119 16.409 16.9085 16.4872C16.9952 16.4983 17.0696 16.5207 17.1439 16.5542C17.2183 16.5765 17.2927 16.61 17.367 16.6546C17.429 16.6881 17.491 16.7439 17.5529 16.7886C17.776 17.0007 17.9123 17.2909 17.9123 17.5811C17.9123 17.8714 17.776 18.1616 17.5529 18.3737C17.3174 18.5746 16.9952 18.6974 16.673 18.6974Z" fill="#D9D9D9" />
                <path d="M22.87 9.58848H1.80063C1.29248 9.58848 0.871094 9.20895 0.871094 8.75127C0.871094 8.2936 1.29248 7.91406 1.80063 7.91406H22.87C23.3782 7.91406 23.7996 8.2936 23.7996 8.75127C23.7996 9.20895 23.3782 9.58848 22.87 9.58848Z" fill="#D9D9D9" />
                <path d="M17.2934 23.9999H7.37837C2.85464 23.9999 0.251953 21.6557 0.251953 17.5813V8.09292C0.251953 4.0185 2.85464 1.67432 7.37837 1.67432H17.2934C21.8171 1.67432 24.4198 4.0185 24.4198 8.09292V17.5813C24.4198 21.6557 21.8171 23.9999 17.2934 23.9999ZM7.37837 3.34873C3.83375 3.34873 2.11102 4.90036 2.11102 8.09292V17.5813C2.11102 20.7738 3.83375 22.3255 7.37837 22.3255H17.2934C20.838 22.3255 22.5607 20.7738 22.5607 17.5813V8.09292C22.5607 4.90036 20.838 3.34873 17.2934 3.34873H7.37837Z" fill="#D9D9D9" />
              </IconDesignacoes>
              <Text className="menu-text">Designações</Text>
            </MenuItem>
          )}

          {allowedPages.includes("eventos") && (
            <MenuItem to="/eventos" className="menu-item">
              <IconFillNone
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 6H4C2.89543 6 2 6.89543 2 8V10C3.10457 10 4 10.8954 4 12C4 13.1046 3.10457 14 2 14V16C2 17.1046 2.89543 18 4 18H20C21.1046 18 22 17.1046 22 16V14C20.8954 14 20 13.1046 20 12C20 10.8954 20.8954 10 22 10V8C22 6.89543 21.1046 6 20 6Z"
                  fill="currentColor"
                />
                <path
                  d="M4 18H20C20.75 18 21.4 17.6 21.8 17C21.92 17.3 22 17.64 22 18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18C2 17.64 2.08 17.3 2.2 17C2.6 17.6 3.25 18 4 18Z"
                  fill="currentColor"
                  opacity="0.5"
                />
              </IconFillNone>
              <Text className="menu-text">Eventos</Text>
            </MenuItem>
          )}

          {allowedPages.includes("chamados") && (
            <MenuItem to="/chamados" className="menu-item">
              <IconFillNone
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="#D9D9D9" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </IconFillNone>
              <Text className="menu-text">Chamados</Text>
            </MenuItem>
          )}

          {allowedPages.includes("publicadores") && (
            <MenuItem to="/publicadores" className="menu-item">
              <IconFillNone
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1.71484 20.5456V19.4547C1.71484 15.2373 4.64534 11.8184 8.26029 11.8184C11.8752 11.8184 14.8057 15.2373 14.8057 19.4547V20.5456" stroke="#D9D9D9" strokeWidth="2.41" strokeLinecap="round" />
                <path d="M12.9355 13.9995C12.9355 10.987 15.0288 8.54492 17.6109 8.54492C20.1929 8.54492 22.2862 10.987 22.2862 13.9995V14.5449" stroke="#D9D9D9" strokeWidth="2.41" strokeLinecap="round" />
                <path d="M8.25979 11.8191C10.3254 11.8191 12 9.86536 12 7.45543C12 5.04546 10.3254 3.0918 8.25979 3.0918C6.1941 3.0918 4.51953 5.04546 4.51953 7.45543C4.51953 9.86536 6.1941 11.8191 8.25979 11.8191Z" stroke="#D9D9D9" strokeWidth="2.41" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M17.6118 8.54546C19.1611 8.54546 20.417 7.0802 20.417 5.27273C20.417 3.46526 19.1611 2 17.6118 2C16.0625 2 14.8066 3.46526 14.8066 5.27273C14.8066 7.0802 16.0625 8.54546 17.6118 8.54546Z" stroke="#D9D9D9" strokeWidth="2.41" strokeLinecap="round" strokeLinejoin="round" />
              </IconFillNone>
              <Text className="menu-text">Publicadores</Text>
            </MenuItem>
          )}

          {allowedPages.includes("experiencias") && (
            <MenuItem to="/experiencias" className="menu-item">
              <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
              </Icon>
              <Text className="menu-text">Experiências</Text>
            </MenuItem>
          )}

          {allowedPages.includes("notificacoes") && (
            <MenuItem to="/notificacoes" className="menu-item">
              <IconFillNone
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M18 8A6 6 0 0 0 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="#D9D9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21" stroke="#D9D9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </IconFillNone>
              <Text className="menu-text">Notificações</Text>
            </MenuItem>
          )}

          {/* Categoria: Coordenação Geral */}
          {mostraCoordenacaoGeral && (
            <MenuCategoryLabel $open={open} className="menu-title">Coordenação Geral</MenuCategoryLabel>
          )}

          {allowedPages.includes("relatorios") && (
            <MenuItem to="/relatorios" className="menu-item">
              <IconFillNone
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M3 3V21H21" stroke="#D9D9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18 9L13.875 13.125L10.125 9.375L6 13.5" stroke="#D9D9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </IconFillNone>
              <Text className="menu-text">Relatórios</Text>
            </MenuItem>
          )}

          {allowedPages.includes("gerenciar-pontos") && (
            <MenuItem to="/gerenciar-pontos" className="menu-item">
              <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
              </Icon>
              <Text className="menu-text">Gerenciar Pontos</Text>
            </MenuItem>
          )}

          {allowedPages.includes("gerenciar-publicadores") && (
            <MenuItem to="/gerenciar-publicadores" className="menu-item">
              <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
              </Icon>
              <Text className="menu-text">Gerenciar Publicadores</Text>
            </MenuItem>
          )}

          {allowedPages.includes("gerenciar-arranjos") && (
            <MenuItem to="/gerenciar-arranjos" className="menu-item">
              <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"/>
              </Icon>
              <Text className="menu-text">Gerenciar Arranjos</Text>
            </MenuItem>
          )}

          {/* Categoria: Cadastro e Suporte
              (Treinamentos e Chamados não existem no sistema hoje, então foram ignorados) */}
          {mostraCadastroSuporte && (
            <MenuCategoryLabel $open={open} className="menu-title">Cadastro e Suporte</MenuCategoryLabel>
          )}

          {allowedPages.includes("cadastrar") && (
            <MenuItem to="/cadastrar" className="menu-item">
              <IconFillNone
                width="24"
                height="22"
                viewBox="0 0 24 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1.71484 20.5456V19.4547C1.71484 15.2373 4.64534 11.8184 8.26029 11.8184C11.8752 11.8184 14.8057 15.2373 14.8057 19.4547V20.5456" stroke="#D9D9D9" strokeWidth="2.41" strokeLinecap="round" />
                <path d="M12.9355 13.9995C12.9355 10.987 15.0288 8.54492 17.6109 8.54492C20.1929 8.54492 22.2862 10.987 22.2862 13.9995V14.5449" stroke="#D9D9D9" strokeWidth="2.41" strokeLinecap="round" />
                <path d="M8.25979 11.8191C10.3254 11.8191 12 9.86536 12 7.45543C12 5.04546 10.3254 3.0918 8.25979 3.0918C6.1941 3.0918 4.51953 5.04546 4.51953 7.45543C4.51953 9.86536 6.1941 11.8191 8.25979 11.8191Z" stroke="#D9D9D9" strokeWidth="2.41" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M17.6118 8.54546C19.1611 8.54546 20.417 7.0802 20.417 5.27273C20.417 3.46526 19.1611 2 17.6118 2C16.0625 2 14.8066 3.46526 14.8066 5.27273C14.8066 7.0802 16.0625 8.54546 17.6118 8.54546Z" stroke="#D9D9D9" strokeWidth="2.41" strokeLinecap="round" strokeLinejoin="round" />
              </IconFillNone>
              <Text className="menu-text">Cadastrar Publicador</Text>
            </MenuItem>
          )}

          {/* Categoria: Administrador */}
          {mostraAdministrador && (
            <MenuCategoryLabel $open={open} className="menu-title">Administrador</MenuCategoryLabel>
          )}

          {allowedPages.includes("comunicacoes-especiais") && (
            <MenuItem to="/comunicacoes-especiais" className="menu-item">
              <IconFillNone
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M3 11v2a1 1 0 0 0 1 1h3l4 4V7L7 11H4a1 1 0 0 0-1 1Z" stroke="#D9D9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15 8a4 4 0 0 1 0 8" stroke="#D9D9D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </IconFillNone>
              <Text className="menu-text">Comunicações Especiais</Text>
            </MenuItem>
          )}

          {allowedPages.includes("suporte") && (
            <MenuItem to="/suporte" className="menu-item">
              <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-6h2v6zm0-8h-2V7h2v4z" />
              </Icon>
              <Text className="menu-text">Suporte</Text>
            </MenuItem>
          )}

          {isAdmin && (
            <MenuItem to="/resetar-senhas" className="menu-item">
              <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M12 1.99997C9.23898 1.99997 7.00049 4.23847 7.00049 6.99947V9.99947H6.00049C5.17198 9.99947 4.50049 10.671 4.50049 11.4995V19.4995C4.50049 20.328 5.17198 20.9995 6.00049 20.9995H18.0005C18.829 20.9995 19.5005 20.328 19.5005 19.4995V11.4995C19.5005 10.671 18.829 9.99947 18.0005 9.99947H17.0005V6.99947C17.0005 4.23847 14.762 1.99997 12 1.99997ZM12 3.99997C13.656 3.99997 15.0005 5.34347 15.0005 6.99947V9.99947H9.00049V6.99947C9.00049 5.34347 10.344 3.99997 12 3.99997ZM15.0005 14.9995C15.0005 15.828 14.329 16.4995 13.5005 16.4995C12.672 16.4995 12.0005 15.828 12.0005 14.9995C12.0005 14.171 12.672 13.4995 13.5005 13.4995C14.329 13.4995 15.0005 14.171 15.0005 14.9995Z" />
              </Icon>
              <Text className="menu-text">Gerenciar Senhas</Text>
            </MenuItem>
          )}

          {allowedPages.includes("swagger") && (
            <MenuItem to="/swagger" className="menu-item">
              <IconFillNone
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" fill="#D9D9D9"/>
                <circle cx="12" cy="12" r="10" stroke="#D9D9D9" strokeWidth="1.5" fill="none"/>
                <path d="M8 9l2 2-2 2M12 15h4" stroke="#D9D9D9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </IconFillNone>
              <Text className="menu-text">Swagger / API</Text>
            </MenuItem>
          )}

          <MenuItemSair onClick={handleLogout} className="menu-item">
            <Icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M16 13v-2H7V8l-5 4 5 4v-3h9zM20 3H9c-1.1 0-2 .9-2 2v3h2V5h11v14H9v-3H7v3c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
            </Icon>
            <Text className="menu-text">Sair</Text>
          </MenuItemSair>
        </MenuItemContainer>
      </MenuContainer>
    </>
  );
};

export default Menu;